/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse } from '../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/payments/worldpay/callback/{cacheKey}
 */
export interface WithCacheKeyItemRequestBuilder extends BaseRequestBuilder<WithCacheKeyItemRequestBuilder> {
    /**
     * The return target WorldPay sends the buyer back to once the hosted card form is submitted. It is anonymous by necessity - the browser arrives with no token - and is identified instead by the single-use key in the route, which carries the state for the transaction it belongs to. Not called directly: it saves the resulting payment method and then redirects the browser on to the return URL the setup call supplied.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<WithCacheKeyItemRequestBuilderGetQueryParameters> | undefined) : Promise<void>;
    /**
     * The return target WorldPay sends the buyer back to once the hosted card form is submitted. It is anonymous by necessity - the browser arrives with no token - and is identified instead by the single-use key in the route, which carries the state for the transaction it belongs to. Not called directly: it saves the resulting payment method and then redirects the browser on to the return URL the setup call supplied.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<WithCacheKeyItemRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * The return target WorldPay sends the buyer back to once the hosted card form is submitted. It is anonymous by necessity - the browser arrives with no token - and is identified instead by the single-use key in the route, which carries the state for the transaction it belongs to. Not called directly: it saves the resulting payment method and then redirects the browser on to the return URL the setup call supplied.
 */
export interface WithCacheKeyItemRequestBuilderGetQueryParameters {
    /**
     * Approval number
     */
    approvalNumber?: string;
    /**
     * Approved amount
     */
    approvedAmount?: string;
    /**
     * Bank identification number
     */
    bin?: string;
    /**
     * Card logo/type (Visa, Mastercard, etc.)
     */
    cardLogo?: string;
    /**
     * Customer number (from route parameter)
     */
    customerNumber?: string;
    /**
     * CVV response code
     */
    cvvResponseCode?: string;
    /**
     * Entry method
     */
    entry?: string;
    /**
     * WorldPay response code (0 = success)
     */
    expressResponseCode?: string;
    /**
     * WorldPay response message
     */
    expressResponseMessage?: string;
    /**
     * Hosted payment status (e.g., "Complete")
     */
    hostedPaymentStatus?: string;
    /**
     * Last four digits of card
     */
    lastFour?: string;
    /**
     * Network transaction ID
     */
    netTranID?: string;
    /**
     * Organization ID (from route parameter)
     */
    organizationId?: string;
    /**
     * Timestamp
     */
    timeStamp?: string;
    /**
     * Transaction date/time
     */
    tranDT?: string;
    /**
     * Transaction ID from WorldPay
     */
    transactionID?: string;
    /**
     * Transaction setup ID
     */
    transactionSetupID?: string;
    /**
     * Validation code
     */
    validationCode?: string;
}
/**
 * Uri template for the request builder.
 */
export const WithCacheKeyItemRequestBuilderUriTemplate = "{+baseurl}/api/payments/worldpay/callback/{cacheKey}?approvalNumber={approvalNumber}&approvedAmount={approvedAmount}&bin={bin}&cardLogo={cardLogo}&customerNumber={customerNumber}&cvvResponseCode={cvvResponseCode}&entry={entry}&expressResponseCode={expressResponseCode}&expressResponseMessage={expressResponseMessage}&hostedPaymentStatus={hostedPaymentStatus}&lastFour={lastFour}&netTranID={netTranID}&organizationId={organizationId}&timeStamp={timeStamp}&tranDT={tranDT}&transactionID={transactionID}&transactionSetupID={transactionSetupID}&validationCode={validationCode}";
/**
 * Metadata for all the requests in the request builder.
 */
export const WithCacheKeyItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithCacheKeyItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
    },
};
/* tslint:enable */
/* eslint-enable */
